import {Link, useLocation} from "react-router";
import {DarkMode} from "./DarkMode";


const Navbar = (props) => {
    const location = useLocation();

    return (
        <nav className="bg-green-100 dark:bg-zinc-800 rounded-xl h-11 flex justify-center w-fit lg:px-2 sm:flex gap-3 m-auto mb-8 text-green-800 dark:text-gray-200" >
            {props.routes.map((route) => (
                <Link
                    key={route.path}
                    to={route.path}
                    className={`${route.displayNav === false ? "hidden" : "flex"} px-3 py-1.5 my-1.5 rounded-lg transition-all text-sm font-medium items-center ${
                        location.pathname === route.path ? "text-green-900 bg-green-200 dark:bg-zinc-700 dark:text-[#1dff73]" : "text-green-800 dark:text-gray-300"
                    } hover:text-opacity-60`}
                >
                    {route.label}
                </Link>
            ))}
            <DarkMode/>
        </nav>
    )
}

export default Navbar;
